<template>
  <div>
    <div class="fullwidth">
      <div class="flex-start">
        <div style="flex-grow:2">
          <div class="exclusive">{{$nippets.exrep}}</div>
          <h1 class="pf-h1">{{ artist.formatted_name }}</h1>
        </div>
        <search-widget right v-if="!mobile" />
      </div>
      <div class="flex-portfolio">
        <div class="pf-one-div">
          <portfolio-intro :artist="artist"  v-on:changeRegion="changeRegion" v-on:load="loadedDetails"  />
        </div>
        <div class="pf-rest-div">
          <portfolio-controls :artist="artist" :details="details" :mobile="mwidth < 1100" />
          <router-view :artist="artist" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchWidget from '@/components/widgets/SearchWidget.vue'
import PortfolioIntro from '@/components/panels/PortfolioIntro.vue'
import PortfolioControls from '@/components/panels/PortfolioControls.vue'
import '@/css/portfolio.css'

export default {
  components: {
    PortfolioIntro,
    SearchWidget,
    PortfolioControls
  },
  props: {
    name: String
  },
  data: function () {
    return {
      artist: { galleries: [], region: ''},
      details: {},
      subhead: '',
      mwidth: 1024
    }
  },
  computed: {
    mobile() {
      return this.mwidth <= 640
    }
  },
  created: function () {
    this.loadData()
  },
  mounted () {
    this.setUpSizing()
    window.addEventListener('resize', this.setUpSizing)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.setUpSizing)
  },
  methods: {
    setUpSizing: function () {
      this.mwidth = window.innerWidth
    },
    loadedDetails (details) {
      this.details = details
    },
    loadData: async function () {
      await this.$store.dispatch('fetchGalleries')
      this.artist = await this.$store.dispatch('fetchArtist', this.name)
      // now grab the videos for this artist
    },
    changeRegion: async function (region) {
      this.$store.commit('setAzLocation', region)
      this.$ixr.push('/artists')
    }
  },
  watch: {
    name: function () {
      this.loadData()
    }
  }
}
</script>

<style>

</style>